import { TeachingLearningSequence } from 'approot/activity-builder/components/teaching-notes/__generated__/TeachingLearningSequence';
import { LEARNING_SEQUENCE_CATEGORY_ACTIVITY_DESCRIPTION } from 'global/constants';

export function getActivityPartsSequenceItems(
  sequences: TeachingLearningSequence[] | null,
  componentId: string
) {
  return (
    sequences?.filter(
      s =>
        s.category === LEARNING_SEQUENCE_CATEGORY_ACTIVITY_DESCRIPTION &&
        s.component?.id === componentId
    ) || []
  );
}
